import locale from './locale';

export default [
  {
    label: __('First Name', locale),
    name: 'firstName',
    required: true,
    isImportField: true,
  },
  {
    label: __('Last Name', locale),
    name: 'lastName',
    required: true,
    isImportField: true,
  },
  {
    label: __('Name', locale),
    required: true,
    isSettingItem: true,
  },
  {
    label: __('Gender', locale),
    name: 'gender',
    required: true,
    isImportField: true,
    isSettingItem: true,
  },
  {
    label: __('DOB', locale),
    name: 'dob',
    isImportField: true,
    isSettingItem: true,
  },
  {
    label: __('Contact Number', locale),
    name: 'phone',
    isImportField: true,
    isSettingItem: true,
  },
  {
    label: __('Tag', locale),
    name: 'tag',
    isImportField: true,
    isSettingItem: true,
  },
  {
    label: __('Parent Name', locale),
    name: 'email',
    isImportField: true,
    isSettingItem: true,
  },
  {
    label: __('Remark', locale),
    name: 'remark',
    isImportField: true,
    isSettingItem: true,
  },
]



// WEBPACK FOOTER //
// ./src/containers/pages/PotentialClientSettings/basicInfoFields.js